import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  createInfluencersApi,
  getManagerListByCompanyIdApi,
  getPaymentByIdApi,
  getProjectByIdApi,
  getUserListApi,
  updateProjectDataByIdApi,
} from '@src/api';
import { CreateInfluencerData } from '@src/api/influencers/index.d';
import { previewPaymentWithoutPaymentIdApi } from '@src/api/projects';
import { PreviewPaymentWithoutPaymentIdParams } from '@src/api/projects/projects';
import type { ProjectUpdateData } from '../types/index';

export const getProjectDetailThunk = createAsyncThunk(
  'project/getProjectDetail',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getProjectByIdApi(id);
      return response.result?.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const getManagersList = createAsyncThunk(
  'project/getManagersList',
  async (companyId: number, { rejectWithValue }) => {
    try {
      const response = await getManagerListByCompanyIdApi(companyId);
      return response.result?.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export interface ExtendsFormdata extends ProjectUpdateData {
  id: number;
}

export const updateProjectData = createAsyncThunk(
  'project/updateProjectData',
  async ({ id, ...argData }: ExtendsFormdata, { rejectWithValue }) => {
    try {
      const response = await updateProjectDataByIdApi(id, argData);
      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const getAdminList = createAsyncThunk(
  'project/getAdminList',
  async (searchValue: string, { rejectWithValue }) => {
    try {
      const response = await getUserListApi({
        searchBy: 'name',
        search: searchValue,
        'filter.role': 'admin',
      });
      return response.result?.data.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const createInfluencerThunk = createAsyncThunk(
  'project/createInfluencer',
  async (data: CreateInfluencerData, { rejectWithValue }) => {
    try {
      const response = await createInfluencersApi(data);
      return response.result?.data.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const previewPaymentWithoutPaymentIdThunk = createAsyncThunk(
  'project/previewPaymentWithoutPaymentId',
  async (
    {
      companyId,
      projectId,
      disablePromotion,
      companyCouponId,
    }: PreviewPaymentWithoutPaymentIdParams,
    { rejectWithValue }
  ) => {
    try {
      const response = await previewPaymentWithoutPaymentIdApi({
        companyId,
        projectId,
        disablePromotion,
        companyCouponId,
      });

      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const getPaymentByIdThunk = createAsyncThunk(
  'project/getPaymentById',
  async ({ paymentId }: { paymentId: string }, { rejectWithValue }) => {
    try {
      const response = await getPaymentByIdApi({ paymentId });

      return response.result.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);
